<template>
  <EditTagsModalV2
    ref="editTagsModal"
    :tags="lensTags"
    :header="'Edit Lens Tags'"
    count-text="creative"
    @deleteTag="deleteTag"
    @editTag="editTag"
    @createTag="createTag"
    @close="$emit('close')"
  />
</template>

<script>
import LensAPI from '@/api/lens'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import EditTagsModalV2 from '../advertisements/EditTagsModalV2.vue'

export default {
  name: 'LensTagModal',
  components: {
    EditTagsModalV2
  },
  computed: {
    ...mapGetters('LensModule', ['getLensTags']),
    lensTags () {
      return this.getLensTags?.map((tag) => {
        return {
          // Map color to tagColors later
          id: tag.tag_id,
          color: tag.color,
          adCount: tag.creative_count,
          name: tag.value
        }
      })
    }
  },
  methods: {
    ...mapActions('LensModule', ['fetchTags']),
    ...mapMutations('LensModule', ['SET_TAGS']),
    async deleteTag (tagId) {
      try {
        await LensAPI.Tags.remove(tagId)
        await this.fetchTags()
        this.$showAlert({ type: 'success', message: 'Tag deleted successfully' })
      } catch (error) {
        console.error('Error deleting tag', error)
      }
    },
    async editTag (tag) {
      try {
        console.log('updating tag', tag)
        const { data } = await LensAPI.Tags.update(tag.id, { value: tag.name, color: tag.color })
        await this.fetchTags()
        this.$showAlert({ type: 'success', message: 'Tag updated successfully' })
      } catch (error) {
        console.error('Error updating tag', error)
      }
    },
    async createTag (newTag) {
      try {
        const { data } = await LensAPI.Tags.create(newTag)
        await this.fetchTags()
        this.$showAlert({ type: 'success', message: 'Tag created successfully' })
      } catch (error) {
        console.error('Error creating tag', error)
      } finally {
        this.$refs.editTagsModal.reset()
      }
    }
  }
}
</script>
